import { useMutation } from "@apollo/client";

import { CourseEditRoute_DeleteDocument } from "../mutations.generated";

export default function useCourseEditRoute_Delete() {
    const [deleteCourse, { loading, error }] = useMutation(CourseEditRoute_DeleteDocument);

    const remove = async (courseId: string) => {
        await deleteCourse({ variables: { input: { courseId } } });
    };

    return {
        deleteCourse: remove,
        loading,
        error,
    };
}
